/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LevelGateType } from './LevelGateType';
import {
    LevelGateTypeFromJSON,
    LevelGateTypeFromJSONTyped,
    LevelGateTypeToJSON,
    LevelGateTypeToJSONTyped,
} from './LevelGateType';
import type { AccountExperienceTransaction } from './AccountExperienceTransaction';
import {
    AccountExperienceTransactionFromJSON,
    AccountExperienceTransactionFromJSONTyped,
    AccountExperienceTransactionToJSON,
    AccountExperienceTransactionToJSONTyped,
} from './AccountExperienceTransaction';

/**
 * 
 * @export
 * @interface AccountLevel
 */
export interface AccountLevel {
    /**
     * 
     * @type {number}
     * @memberof AccountLevel
     */
    level: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLevel
     */
    totalExperience: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLevel
     */
    experienceRequiredForNextLevel: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLevel
     */
    experienceGainedAtThisLevel: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLevel
     */
    userOwnsIndustryCollectionNft: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLevel
     */
    ownsIndustryPassNft: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLevel
     */
    userRequiresIndustryCollectionNftToLevelUp: boolean;
    /**
     * 
     * @type {Array<AccountExperienceTransaction>}
     * @memberof AccountLevel
     */
    transactions: Array<AccountExperienceTransaction>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLevel
     */
    lootboxOnePreviouslyGained?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLevel
     */
    progressionBlockedByGate?: boolean;
    /**
     * 
     * @type {Array<LevelGateType>}
     * @memberof AccountLevel
     */
    blockingGateTypes?: Array<LevelGateType>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLevel
     */
    awaitingGateReleaseBaseline?: boolean;
}

/**
 * Check if a given object implements the AccountLevel interface.
 */
export function instanceOfAccountLevel(value: object): value is AccountLevel {
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('totalExperience' in value) || value['totalExperience'] === undefined) return false;
    if (!('experienceRequiredForNextLevel' in value) || value['experienceRequiredForNextLevel'] === undefined) return false;
    if (!('experienceGainedAtThisLevel' in value) || value['experienceGainedAtThisLevel'] === undefined) return false;
    if (!('userOwnsIndustryCollectionNft' in value) || value['userOwnsIndustryCollectionNft'] === undefined) return false;
    if (!('ownsIndustryPassNft' in value) || value['ownsIndustryPassNft'] === undefined) return false;
    if (!('userRequiresIndustryCollectionNftToLevelUp' in value) || value['userRequiresIndustryCollectionNftToLevelUp'] === undefined) return false;
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    return true;
}

export function AccountLevelFromJSON(json: any): AccountLevel {
    return AccountLevelFromJSONTyped(json, false);
}

export function AccountLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountLevel {
    if (json == null) {
        return json;
    }
    return {
        
        'level': json['level'],
        'totalExperience': json['totalExperience'],
        'experienceRequiredForNextLevel': json['experienceRequiredForNextLevel'],
        'experienceGainedAtThisLevel': json['experienceGainedAtThisLevel'],
        'userOwnsIndustryCollectionNft': json['userOwnsIndustryCollectionNft'],
        'ownsIndustryPassNft': json['ownsIndustryPassNft'],
        'userRequiresIndustryCollectionNftToLevelUp': json['userRequiresIndustryCollectionNftToLevelUp'],
        'transactions': ((json['transactions'] as Array<any>).map(AccountExperienceTransactionFromJSON)),
        'lootboxOnePreviouslyGained': json['lootboxOnePreviouslyGained'] == null ? undefined : json['lootboxOnePreviouslyGained'],
        'progressionBlockedByGate': json['progressionBlockedByGate'] == null ? undefined : json['progressionBlockedByGate'],
        'blockingGateTypes': json['blockingGateTypes'] == null ? undefined : ((json['blockingGateTypes'] as Array<any>).map(LevelGateTypeFromJSON)),
        'awaitingGateReleaseBaseline': json['awaitingGateReleaseBaseline'] == null ? undefined : json['awaitingGateReleaseBaseline'],
    };
}

export function AccountLevelToJSON(json: any): AccountLevel {
    return AccountLevelToJSONTyped(json, false);
}

export function AccountLevelToJSONTyped(value?: AccountLevel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': value['level'],
        'totalExperience': value['totalExperience'],
        'experienceRequiredForNextLevel': value['experienceRequiredForNextLevel'],
        'experienceGainedAtThisLevel': value['experienceGainedAtThisLevel'],
        'userOwnsIndustryCollectionNft': value['userOwnsIndustryCollectionNft'],
        'ownsIndustryPassNft': value['ownsIndustryPassNft'],
        'userRequiresIndustryCollectionNftToLevelUp': value['userRequiresIndustryCollectionNftToLevelUp'],
        'transactions': ((value['transactions'] as Array<any>).map(AccountExperienceTransactionToJSON)),
        'lootboxOnePreviouslyGained': value['lootboxOnePreviouslyGained'],
        'progressionBlockedByGate': value['progressionBlockedByGate'],
        'blockingGateTypes': value['blockingGateTypes'] == null ? undefined : ((value['blockingGateTypes'] as Array<any>).map(LevelGateTypeToJSON)),
        'awaitingGateReleaseBaseline': value['awaitingGateReleaseBaseline'],
    };
}

